import AdminCompleteCaseDetails from 'Components/Admin/AdminCompleteCaseDetails'
import useIsMobile from 'Hooks/useIsMobile'
import React from 'react'
import ReactModal from 'react-modal'

function AdminCaseDetailsModal({uploadNew, onClose, caseId}) {
  const isMobile = useIsMobile();
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 25
        },
        content: {
            height: isMobile ? "400px" : '-webkit-calc(100% - 100px)',
            width: isMobile ? '350px' : '-webkit-calc(100% - 400px)',
            top:  isMobile ? '50%' : '500px',
            left: '50%',
            padding: isMobile ? "0px" : "20px",
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgb(240 249 255)',
            boxShadow: "2px 3px 10px #9E9E9E"
        }
      }}
    >    
       <AdminCompleteCaseDetails id={caseId} onClose={onClose}/>
    </ReactModal>
  )
}

export default AdminCaseDetailsModal